import { axiosInstance } from '@/axiosInstance.js';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

export function getUrlFromSwaggerUrl(urlWithSwagger: string | undefined): string {
  if (!urlWithSwagger) {
    return '';
  }

  const protocol = urlWithSwagger.startsWith('https') ? 'https' : 'http';
  const host = urlWithSwagger.split('//')[1]?.split('/')[0];

  return host ? `${protocol}://${host}` : '';
}

// Turn endpoints that must be sent with credentials so the backend can set the
// auth cookie the follow-up audio stream fetch relies on (GET /api/Process/TurnAudio
// is requested with `credentials: 'include'`). Without it that fetch is
// unauthenticated (401) and the patient's spoken reply plays no sound. Both the
// scenario chat (`/api/Process/RespondToUserTurn`) and the VITAL stations
// (`/api/Simulation/respond-turn`) drive the same TurnAudio endpoint.
const CREDENTIALED_TURN_ENDPOINTS = ['/api/Process/RespondToUserTurn', '/api/Simulation/respond-turn'];

// CRITICAL: Use the SAME axiosInstance that has MSAL auth interceptors
// This ensures Orval-generated hooks have identical authentication to current API clients
export const customAxiosInstance = <T = unknown>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
  const baseURL = getUrlFromSwaggerUrl(process.env.REACT_APP_SCENES);
  const withCredentials = CREDENTIALED_TURN_ENDPOINTS.includes(config.url ?? '') ? true : config.withCredentials;

  // This uses the exact same instance that gets auth interceptors in api.ts:setAccessTokenRequestInterceptor()
  return axiosInstance({
    ...config,
    withCredentials,
    url: baseURL + config.url
  });
};

export default customAxiosInstance;
